import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _GradingHeader;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Alert } from '@instructure/ui-alerts';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import { withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import { FormattedTimer as FormattedDuration, formatTime } from '@instructure/quiz-core';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var GradingHeader = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_GradingHeader = /*#__PURE__*/function (_withI18nSupport) {
  function GradingHeader() {
    var _this;
    _classCallCheck(this, GradingHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GradingHeader, [].concat(args));
    _defineProperty(_this, "scrollToSessionItem", function (sessionItem) {
      return function () {
        _this.props.scrollToItem(sessionItem.get('id'));
      };
    });
    _defineProperty(_this, "setRef", function (itemRef) {
      _this.itemRef = itemRef;
    });
    return _this;
  }
  _inherits(GradingHeader, _withI18nSupport);
  return _createClass(GradingHeader, [{
    key: "percentage",
    value: function percentage() {
      return this.formatPercentMax2FractionDigits(this.props.quizSessionResult.percentage);
    }
  }, {
    key: "points",
    value: function points() {
      return t.number(this.props.quizSessionResult.score);
    }
  }, {
    key: "pointsPossible",
    value: function pointsPossible() {
      return this.props.quizSessionResult && this.props.quizSessionResult.pointsPossible;
    }
  }, {
    key: "alertContent",
    value: function alertContent(sessionItemsNeedingReview, message) {
      var _this2 = this;
      return jsx("div", null, jsx("div", null, message), jsx("ul", null, sessionItemsNeedingReview.map(function (sessionItem) {
        return jsx("li", {
          key: sessionItem.get('position')
        }, jsx(Link, {
          role: "link",
          isWithinText: false,
          onClick: _this2.scrollToSessionItem(sessionItem)
        }, t('Question {position, number}', {
          position: sessionItem.get('position')
        })));
      })));
    }
  }, {
    key: "renderAutogradingFailedInfo",
    value: function renderAutogradingFailedInfo() {
      var _this$props = this.props,
        sessionItemResults = _this$props.sessionItemResults,
        quizSessionResult = _this$props.quizSessionResult;
      var sessionItemsAutogradingFailed = sessionItemResults.filter(function (sir) {
        return sir.getIn(['scoredData', 'unscorable']);
      }).sortBy(function (sir) {
        return sir.get('position');
      });
      if (quizSessionResult.autogradingFailed() && sessionItemsAutogradingFailed.size) {
        var message = t('Autograding failed on the following items:');
        return jsx("div", {
          css: this.props.styles.alertWrapper
        }, jsx(Alert, {
          variant: "warning"
        }, this.alertContent(sessionItemsAutogradingFailed, message)));
      }
    }
  }, {
    key: "renderUngradedInfo",
    value: function renderUngradedInfo() {
      var sessionItemsNeedingReview = this.props.sessionItemResults.filter(function (sir) {
        return sir.get('score') === null;
      }).sortBy(function (sir) {
        return sir.get('position');
      });
      if (sessionItemsNeedingReview.size) {
        var message = t('The following questions need review:');
        return jsx("div", {
          css: this.props.styles.alertWrapper
        }, jsx(Alert, {
          variant: "info"
        }, this.alertContent(sessionItemsNeedingReview, message)));
      }
    }
  }, {
    key: "PrimaryContent",
    value: function PrimaryContent(_ref) {
      var children = _ref.children;
      return jsx(Text, {
        as: "div",
        color: "primary",
        size: "xx-large",
        weight: "bold",
        "data-automation": "sdk-grading-primary"
      }, children);
    }
  }, {
    key: "SecondaryContent",
    value: function SecondaryContent(_ref2) {
      var children = _ref2.children;
      return jsx(Text, {
        color: "secondary",
        "data-automation": "sdk-grading-secondary"
      }, children);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focusOnMount) {
        this.itemRef && this.itemRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var scoreText = t('Score');
      var pointsPossibleText = t("Out of { points, plural,\n        one {# point}\n      other {# points}\n    }", {
        points: this.pointsPossible()
      });
      var attemptText = t('Time for this attempt');
      return jsx("div", {
        css: this.props.styles.root,
        tabIndex: "-1"
      }, jsx("h1", {
        "data-testid": "test-head-title",
        ref: this.setRef,
        tabIndex: "-1"
      }, jsx(Text, {
        color: "primary",
        size: "xx-large"
      }, t('Results'))), jsx("div", {
        className: "fs-mask",
        css: this.props.styles.pointsAndPercentage,
        "data-automation": "sdk-grading-points"
      }, jsx(AccessibleContent, {
        alt: t('Score: { percentage }', {
          percentage: this.percentage()
        })
      }, jsx(this.PrimaryContent, null, this.percentage()), jsx(this.SecondaryContent, null, scoreText)), jsx(AccessibleContent, {
        alt: t('{ points } out of { pointsPossible, plural, one {# point} other {# points} }', {
          points: this.points(),
          pointsPossible: this.pointsPossible()
        })
      }, jsx(this.PrimaryContent, null, this.points()), jsx(this.SecondaryContent, null, pointsPossibleText)), jsx(AccessibleContent, {
        alt: t('Time for this attempt: { time }', {
          time: formatTime(this.props.quizSession.elapsedTime)
        })
      }, jsx(this.PrimaryContent, null, jsx(FormattedDuration, {
        fontSize: "xx-large",
        seconds: this.props.quizSession.elapsedTime
      })), jsx(this.SecondaryContent, null, attemptText))), this.renderAutogradingFailedInfo(), this.renderUngradedInfo());
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_GradingHeader, "displayName", 'GradingHeader'), _defineProperty(_GradingHeader, "componentId", "Quizzes".concat(_GradingHeader.displayName)), _defineProperty(_GradingHeader, "propTypes", {
  focusOnMount: PropTypes.bool,
  quizSession: ImmutablePropTypes.record.isRequired,
  quizSessionResult: ImmutablePropTypes.record.isRequired,
  scrollToItem: PropTypes.func.isRequired,
  sessionItemResults: ImmutablePropTypes.list.isRequired,
  styles: PropTypes.object
}), _defineProperty(_GradingHeader, "defaultProps", {
  focusOnMount: true
}), _GradingHeader)) || _class);
export default GradingHeader;